<mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    <input matInput [matTooltip]="toolTip" [formControl]="formCtrl" [matAutocomplete]="auto" placeholder="{{placeHolder}}">
    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let opt of filteredOptions | async" [value]="opt.key">
            {{opt.value}}
        </mat-option>
    </mat-autocomplete>
    <button type="button" *ngIf="formCtrl.value!==''" matSuffix aria-label="Clear"
        [hidden]="disableClearBtn" (click)="clearControl()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-error *ngIf="formCtrl.errors">{{errormessage}}</mat-error>

</mat-form-field>

